export default {
	headers: [
		{
			text: 'Prénom',
			align: 'left',
			value: 'firstname'
		},
		{
			text: 'Nom',
			align: 'left',
			value: 'lastname'
		},
		{
			text: 'Login',
			align: 'left',
			value: 'mail'
		},
		{
			text: 'Profil',
			align: 'left',
			value: 'roles'
		},
		{
			text: 'Statut du compte',
			align: 'left',
			value: 'status'
		},
		{
			align: 'right',
			sortable: false,
			value: 'action'
		}
	],
	nbRowText: '0 utilisateur | 1 utilisateur | {count} utilisateurs',
	deleteDialogTitle: 'Êtes vous sûr de vouloir supprimer l’utilisateur ?',
	successAddMessage: 'L’utilisateur a été ajouté avec succès',
	successEditMessage: 'Les informations de l’utilisateur ont été modifiées avec succès',
	successDeleteMessage: 'L’utilisateur a été supprimé avec succès',
	btnCreate: 'Ajouter un utilisateur',
	btnAdd: 'Valider',
	addTitle: 'Ajouter un utilisateur',
	editTitle: 'Modifier un utilisateur',
	conflictExceptionMessage: '',
	form: {
		mail: {
			label: 'Email',
			rules: [
				{
					name: 'requiredFn'
				},
				{
					name: 'emailFn'
				}
			]
		},
		usersActors: {
			rules: [
				{
					name: 'requiredFn'
				}
			]
		}
	},
	statusAccount: {
		finalized: 'Finalisé',
		initialized: 'Initialisé'
	}
};
